import { RouteMenu } from "model/other";

const routesNotShowInMenu: Array<RouteMenu> = [
];

export default routesNotShowInMenu;
